import React from "react";

export interface Props {
	children?: React.ReactNode;
}

export const Main: React.FC<Props> = ({ children }) => (
	<main className="o-main">{children}</main>
);
